let getH5CallClient = () => import('./core/callClient');
let isLoading = false;
let client = null;

export async function getClientAdapter() {
    let clientQueue = [];
    if (client) {
        return client;
    }
    if (isLoading) {
        return new Promise((resolve) => {
            clientQueue.push(client => resolve(client));
        });
    }
    isLoading = true;
    let clientModule = await getH5CallClient();
    window.callClient = client = clientModule.default;
    isLoading = false;
    clientQueue.forEach(item => item(client));
    clientQueue = [];
    return client;
}